import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "overflow": "auto"
  },
  "element-loading-text": "加载系统数据中..."
};
const _hoisted_2 = {
  class: "el-table el-table--enable-row-hover el-table--medium"
};
const _hoisted_3 = {
  cellspacing: "0",
  style: {
    "width": "100%"
  }
};
const _hoisted_4 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_5 = {
  key: 0,
  class: "cell"
};
const _hoisted_6 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_7 = {
  key: 0,
  class: "cell"
};
const _hoisted_8 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_9 = {
  key: 0,
  class: "cell"
};
const _hoisted_10 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_11 = {
  key: 0,
  class: "cell"
};
const _hoisted_12 = {
  class: "el-table el-table--enable-row-hover el-table--medium"
};
const _hoisted_13 = {
  cellspacing: "0",
  style: {
    "width": "100%"
  }
};
const _hoisted_14 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_15 = {
  key: 0,
  class: "cell"
};
const _hoisted_16 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_17 = {
  key: 0,
  class: "cell"
};
const _hoisted_18 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_19 = {
  key: 0,
  class: "cell"
};
const _hoisted_20 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_21 = {
  key: 0,
  class: "cell"
};
const _hoisted_22 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_23 = {
  key: 0,
  class: "cell"
};
const _hoisted_24 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_25 = {
  key: 0,
  class: "cell"
};
const _hoisted_26 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_27 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_28 = {
  class: "el-table el-table--enable-row-hover el-table--medium"
};
const _hoisted_29 = {
  cellspacing: "0",
  style: {
    "width": "100%"
  }
};
const _hoisted_30 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_31 = {
  key: 0,
  class: "cell"
};
const _hoisted_32 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_33 = {
  key: 0,
  class: "cell"
};
const _hoisted_34 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_35 = {
  key: 0,
  class: "cell"
};
const _hoisted_36 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_37 = {
  key: 0,
  class: "cell"
};
const _hoisted_38 = {
  class: "el-table el-table--enable-row-hover el-table--medium"
};
const _hoisted_39 = {
  cellspacing: "0",
  style: {
    "width": "100%",
    "table-layout": "fixed"
  }
};
const _hoisted_40 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_41 = {
  key: 0,
  class: "cell"
};
const _hoisted_42 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_43 = {
  key: 0,
  class: "cell"
};
const _hoisted_44 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_45 = {
  key: 0,
  class: "cell"
};
const _hoisted_46 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_47 = {
  key: 0,
  class: "cell"
};
const _hoisted_48 = {
  colspan: "3",
  class: "el-table__cell is-leaf"
};
const _hoisted_49 = {
  key: 0,
  class: "cell"
};
const _hoisted_50 = {
  colspan: "3",
  class: "el-table__cell is-leaf"
};
const _hoisted_51 = {
  key: 0,
  class: "cell"
};
const _hoisted_52 = {
  colspan: "3",
  class: "el-table__cell is-leaf"
};
const _hoisted_53 = {
  key: 0,
  class: "cell"
};
const _hoisted_54 = {
  class: "el-table el-table--enable-row-hover el-table--medium"
};
const _hoisted_55 = {
  cellspacing: "0",
  style: {
    "width": "100%"
  }
};
const _hoisted_56 = {
  key: 0
};
const _hoisted_57 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_58 = {
  class: "cell"
};
const _hoisted_59 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_60 = {
  class: "cell"
};
const _hoisted_61 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_62 = {
  class: "cell"
};
const _hoisted_63 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_64 = {
  class: "cell"
};
const _hoisted_65 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_66 = {
  class: "cell"
};
const _hoisted_67 = {
  class: "el-table__cell is-leaf"
};
const _hoisted_68 = {
  class: "cell"
};
const _hoisted_69 = {
  class: "el-table__cell is-leaf"
};
import * as echarts from 'echarts';
import { monitor } from '@/api/system/monitor';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Sysmonitor',
  setup(__props) {
    const server = ref({});
    const loading = ref(false);
    onMounted(() => {
      getList();
    });
    /** 查询服务器信息 */
    function getList() {
      loading.value = true;
      monitor().then(response => {
        server.value = response.data;
        initCpuCharts(server.value.cpu);
        initMemCharts(server.value.mem);
        initJvmCharts(server.value.jvm);
        loading.value = false;
      });
    }
    function initCpuCharts(cpu) {
      let cpuall = cpu.used + cpu.sys;
      cpuall = cpuall.toFixed(2);
      const chartDom = document.getElementById('cpu');
      const myChart = echarts.init(chartDom);
      window.onresize = function () {
        myChart.resize();
      };
      const option = {
        series: [{
          name: 'CPU使用率',
          type: 'gauge',
          detail: {
            formatter: '{value}%',
            fontSize: '17px'
          },
          data: [{
            value: cpuall,
            name: 'CPU'
          }]
        }]
      };
      option && myChart.setOption(option);
    }
    function initMemCharts(mem) {
      const chartDom = document.getElementById('mem');
      const myChart = echarts.init(chartDom);
      window.onresize = function () {
        myChart.resize();
      };
      const option = {
        series: [{
          name: '内存',
          type: 'gauge',
          detail: {
            formatter: '{value}%',
            fontSize: '17px'
          },
          data: [{
            value: mem.usage,
            name: '内存'
          }]
        }]
      };
      option && myChart.setOption(option);
    }
    function initJvmCharts(jvm) {
      const chartDom = document.getElementById('jvm');
      const myChart = echarts.init(chartDom);
      window.onresize = function () {
        myChart.resize();
      };
      const option = {
        series: [{
          name: 'JVM',
          type: 'gauge',
          detail: {
            formatter: '{value}%',
            fontSize: '17px'
          },
          data: [{
            value: jvm.usage,
            name: 'JVM'
          }]
        }]
      };
      option && myChart.setOption(option);
    }
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_x_app_layout = _resolveComponent("x-app-layout");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_x_app_layout, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
          height: "100%"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12,
              class: "card-box"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_card, null, {
                header: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("span", null, "CPU", -1)])),
                default: _withCtx(() => [_createVNode(_component_el_row, null, {
                  default: _withCtx(() => [_createVNode(_component_el_col, null, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("div", {
                      id: "cpu",
                      style: {
                        "height": "350px"
                      }
                    }, null, -1)])),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("table", _hoisted_3, [_cache[6] || (_cache[6] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "属性")]), _createElementVNode("th", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "值")])])], -1)), _createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[2] || (_cache[2] = _createElementVNode("td", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "核心数")], -1)), _createElementVNode("td", _hoisted_4, [_unref(server).cpu ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(server).cpu.cpuNum), 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[3] || (_cache[3] = _createElementVNode("td", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "用户使用率")], -1)), _createElementVNode("td", _hoisted_6, [_unref(server).cpu ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(server).cpu.used) + "%", 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[4] || (_cache[4] = _createElementVNode("td", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "系统使用率")], -1)), _createElementVNode("td", _hoisted_8, [_unref(server).cpu ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(server).cpu.sys) + "%", 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[5] || (_cache[5] = _createElementVNode("td", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "当前空闲率")], -1)), _createElementVNode("td", _hoisted_10, [_unref(server).cpu ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(server).cpu.free) + "%", 1)) : _createCommentVNode("", true)])])])])])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12,
              class: "card-box"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_card, null, {
                header: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("div", null, [_createElementVNode("span", null, "内存")], -1)])),
                default: _withCtx(() => [_createVNode(_component_el_row, null, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("div", {
                      id: "mem",
                      style: {
                        "height": "350px"
                      }
                    }, null, -1)])),
                    _: 1
                  }), _createVNode(_component_el_col, {
                    span: 12
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("div", {
                      id: "jvm",
                      style: {
                        "height": "350px"
                      }
                    }, null, -1)])),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("table", _hoisted_13, [_cache[14] || (_cache[14] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "属性")]), _createElementVNode("th", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "内存")]), _createElementVNode("th", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "JVM")])])], -1)), _createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[10] || (_cache[10] = _createElementVNode("td", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "总内存")], -1)), _createElementVNode("td", _hoisted_14, [_unref(server).mem ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(server).mem.total) + "G", 1)) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_16, [_unref(server).jvm ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(server).jvm.total) + "M", 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[11] || (_cache[11] = _createElementVNode("td", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "已用内存")], -1)), _createElementVNode("td", _hoisted_18, [_unref(server).mem ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_unref(server).mem.used) + "G", 1)) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_20, [_unref(server).jvm ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(server).jvm.used) + "M", 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[12] || (_cache[12] = _createElementVNode("td", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "剩余内存")], -1)), _createElementVNode("td", _hoisted_22, [_unref(server).mem ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(server).mem.free) + "G", 1)) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_24, [_unref(server).jvm ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(server).jvm.free) + "M", 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[13] || (_cache[13] = _createElementVNode("td", {
                    class: "el-table__cell is-leaf"
                  }, [_createElementVNode("div", {
                    class: "cell"
                  }, "使用率")], -1)), _createElementVNode("td", _hoisted_26, [_unref(server).mem ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["cell", {
                      'text-danger': _unref(server).mem.usage > 80
                    }])
                  }, _toDisplayString(_unref(server).mem.usage) + "%", 3)) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_27, [_unref(server).jvm ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["cell", {
                      'text-danger': _unref(server).jvm.usage > 80
                    }])
                  }, _toDisplayString(_unref(server).jvm.usage) + "%", 3)) : _createCommentVNode("", true)])])])])])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24,
              class: "card-box"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_card, null, {
                header: _withCtx(() => _cache[15] || (_cache[15] = [_createElementVNode("div", null, [_createElementVNode("span", null, "服务器信息")], -1)])),
                default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_createElementVNode("table", _hoisted_29, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[16] || (_cache[16] = _createElementVNode("td", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "服务器名称")], -1)), _createElementVNode("td", _hoisted_30, [_unref(server).sys ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(server).sys.computerName), 1)) : _createCommentVNode("", true)]), _cache[17] || (_cache[17] = _createElementVNode("td", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "操作系统")], -1)), _createElementVNode("td", _hoisted_32, [_unref(server).sys ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_unref(server).sys.osName), 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[18] || (_cache[18] = _createElementVNode("td", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "服务器IP")], -1)), _createElementVNode("td", _hoisted_34, [_unref(server).sys ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_unref(server).sys.computerIp), 1)) : _createCommentVNode("", true)]), _cache[19] || (_cache[19] = _createElementVNode("td", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "系统架构")], -1)), _createElementVNode("td", _hoisted_36, [_unref(server).sys ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_unref(server).sys.osArch), 1)) : _createCommentVNode("", true)])])])])])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24,
              class: "card-box"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_card, null, {
                header: _withCtx(() => _cache[20] || (_cache[20] = [_createElementVNode("div", null, [_createElementVNode("span", null, "Java虚拟机信息")], -1)])),
                default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_createElementVNode("table", _hoisted_39, [_createElementVNode("tbody", null, [_createElementVNode("tr", null, [_cache[21] || (_cache[21] = _createElementVNode("td", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "Java名称")], -1)), _createElementVNode("td", _hoisted_40, [_unref(server).jvm ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_unref(server).jvm.name), 1)) : _createCommentVNode("", true)]), _cache[22] || (_cache[22] = _createElementVNode("td", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "Java版本")], -1)), _createElementVNode("td", _hoisted_42, [_unref(server).jvm ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_unref(server).jvm.version), 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[23] || (_cache[23] = _createElementVNode("td", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "启动时间")], -1)), _createElementVNode("td", _hoisted_44, [_unref(server).jvm ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_unref(server).jvm.startTime), 1)) : _createCommentVNode("", true)]), _cache[24] || (_cache[24] = _createElementVNode("td", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "运行时长")], -1)), _createElementVNode("td", _hoisted_46, [_unref(server).jvm ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_unref(server).jvm.runTime), 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[25] || (_cache[25] = _createElementVNode("td", {
                  colspan: "1",
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "安装路径")], -1)), _createElementVNode("td", _hoisted_48, [_unref(server).jvm ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_unref(server).jvm.home), 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[26] || (_cache[26] = _createElementVNode("td", {
                  colspan: "1",
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "项目路径")], -1)), _createElementVNode("td", _hoisted_50, [_unref(server).sys ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_unref(server).sys.userDir), 1)) : _createCommentVNode("", true)])]), _createElementVNode("tr", null, [_cache[27] || (_cache[27] = _createElementVNode("td", {
                  colspan: "1",
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "运行参数")], -1)), _createElementVNode("td", _hoisted_52, [_unref(server).jvm ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_unref(server).jvm.inputArgs), 1)) : _createCommentVNode("", true)])])])])])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 24,
              class: "card-box"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_card, null, {
                header: _withCtx(() => _cache[28] || (_cache[28] = [_createElementVNode("div", null, [_createElementVNode("span", null, "磁盘状态")], -1)])),
                default: _withCtx(() => [_createElementVNode("div", _hoisted_54, [_createElementVNode("table", _hoisted_55, [_cache[29] || (_cache[29] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", {
                  class: "el-table__cell el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "盘符路径")]), _createElementVNode("th", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "文件系统")]), _createElementVNode("th", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "盘符类型")]), _createElementVNode("th", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "总大小")]), _createElementVNode("th", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "可用大小")]), _createElementVNode("th", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "已用大小")]), _createElementVNode("th", {
                  class: "el-table__cell is-leaf"
                }, [_createElementVNode("div", {
                  class: "cell"
                }, "已用百分比")])])], -1)), _unref(server).sysFiles ? (_openBlock(), _createElementBlock("tbody", _hoisted_56, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(server).sysFiles, (sysFile, index) => {
                  return _openBlock(), _createElementBlock("tr", {
                    key: index
                  }, [_createElementVNode("td", _hoisted_57, [_createElementVNode("div", _hoisted_58, _toDisplayString(sysFile.dirName), 1)]), _createElementVNode("td", _hoisted_59, [_createElementVNode("div", _hoisted_60, _toDisplayString(sysFile.sysTypeName), 1)]), _createElementVNode("td", _hoisted_61, [_createElementVNode("div", _hoisted_62, _toDisplayString(sysFile.typeName), 1)]), _createElementVNode("td", _hoisted_63, [_createElementVNode("div", _hoisted_64, _toDisplayString(sysFile.total), 1)]), _createElementVNode("td", _hoisted_65, [_createElementVNode("div", _hoisted_66, _toDisplayString(sysFile.free), 1)]), _createElementVNode("td", _hoisted_67, [_createElementVNode("div", _hoisted_68, _toDisplayString(sysFile.used), 1)]), _createElementVNode("td", _hoisted_69, [_createElementVNode("div", {
                    class: _normalizeClass(["cell", {
                      'text-danger': sysFile.usage > 80
                    }])
                  }, _toDisplayString(sysFile.usage) + "%", 3)])]);
                }), 128))])) : _createCommentVNode("", true)])])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })])), [[_directive_loading, _unref(loading)]])]),
        _: 1
      });
    };
  }
});